import React from 'react';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import styles from './ClaimBookingStep.module.scss';

type ClaimBookingSuccessProps = {
  tabId: string;
  onClickLogin: () => void;
};
const ClaimBookingSuccess: React.FC<ClaimBookingSuccessProps> = ({ tabId, onClickLogin }) => {
  const appUiData = useAppUiData();
  return (
    <WizardStep tabId={tabId}>
      <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.successPleaseLogIn]}</h2>
      <p className={styles.subtitle}>{appUiData[appUiIds.claimBooking.successSubtext]}</p>
      <Button variant="primary" onClick={onClickLogin} className={styles.buttonLogin}>
        Login
      </Button>
    </WizardStep>
  );
};

export default ClaimBookingSuccess;
